'use strict'

import $ from 'jquery'

window._axcb = window._axcb || []

export default function () {
    window._axcb.push(function(sdk) {
        sdk.on('cookies:complete', function (choices) {
            document
                .querySelectorAll('[data-hide-on-vendor-consent]')
                .forEach(el => {
                    const vendor = el.getAttribute('data-hide-on-vendor-consent')
                    const display = $(el).css('display')
                    el.style.display = choices[vendor] ? 'none' : display;
                })
            document
                .querySelectorAll('[data-requires-vendor-consent]')
                .forEach(el => {
                    const vendor = el.getAttribute('data-requires-vendor-consent')
                    if (choices[vendor]) {
                        el.setAttribute('src', el.getAttribute('data-src'))
                    }
                })
        })

        $('[data-hide-on-vendor-consent]').find('button').on('click', function() {
            const vendor = $(this).parent().data('hide-on-vendor-consent')
            window.axeptioSDK.requestConsent(vendor)
        })
    })

    // Axeptio plugin deactivated case
    if ( 'undefined' === typeof window.axeptioSettings ) {
        document
            .querySelectorAll('[data-hide-on-vendor-consent]')
            .forEach(el => {
                el.style.display = 'none'
            })
        document
            .querySelectorAll('[data-requires-vendor-consent]')
            .forEach(el => {
                el.setAttribute('src', el.getAttribute('data-src'));
            })
    }
}
